import React from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "@sscs/ui";
import styles from "./groupName.module.scss";

type GroupNameProps = {
  name: string;
};
const GroupName = ({ name }: GroupNameProps): React.JSX.Element => {
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <div className={styles["group-name"]}>
      <Form.TextField
        name={name}
        id={name}
        errors={errors}
        helperText="Group name in your SSO identity provider"
      />
    </div>
  );
};

export default GroupName;
